import { BOARD, GROUPS, LEVEL_NAMES } from '../game/board'
import { downPayment, loanMonthly, rentFor } from '../game/engine'
import type { GameState } from '../game/types'
import { money, short } from '../util/format'
import { TileArt } from './TileArt'

/**
 * รายละเอียดของช่องที่ผู้เล่นแตะ — จำเป็นบนมือถือที่ tooltip ใช้ไม่ได้
 * และช่องเล็กจนแสดงได้แค่อีโมจิ
 */
export function TileInfo({ g, tileId, onClose }: { g: GameState; tileId: number; onClose: () => void }) {
  const tile = BOARD[tileId]
  const ts = g.tiles[tileId]
  const owner = ts.ownerId !== null ? g.players[ts.ownerId] : null
  const group = tile.group ? GROUPS[tile.group] : null
  const me = g.players[g.current]
  const monthly = tile.monthly?.[Math.min(ts.level, (tile.monthly?.length ?? 1) - 1)] ?? 0

  return (
    <div className="card tileinfo">
      <div className="tileinfo-head">
        <TileArt icon={tile.icon} emoji={tile.emoji} className="tileinfo-emoji" alt={tile.name} />
        <span className="tileinfo-id">
          <b>{tile.name}</b>
          <em className="faint tiny">
            {group?.name ??
              { transport: 'ท่าขนส่ง', utility: 'สาธารณูปโภค', deal: 'การ์ดโอกาส', event: 'การ์ดเหตุการณ์' }[
                tile.kind as 'transport' | 'utility' | 'deal' | 'event'
              ] ??
              'ช่องพิเศษ'}
            {tile.kind === 'property' ? ` · ${LEVEL_NAMES[ts.level]}` : ''}
          </em>
        </span>
        <button className="btn btn-sm btn-ghost" onClick={onClose} aria-label="ปิด">
          ✕
        </button>
      </div>

      {tile.note && <p className="faint tiny">{tile.note}</p>}

      {tile.price !== undefined && (
        <>
          <div className="tileinfo-stats">
            <span>
              <em className="faint tiny">ราคา</em>
              <b className="num">{money(tile.price)}</b>
            </span>
            <span>
              <em className="faint tiny">ผ่อน ดาวน์</em>
              <b className="num">
                {short(downPayment(me, tile.price))}
                <span className="faint"> ·{short(loanMonthly(tile.price - downPayment(me, tile.price)))}/ด.</span>
              </b>
            </span>
            <span>
              <em className="faint tiny">กระแสเงินสด</em>
              <b className="num good-text">+{money(monthly)}/ด.</b>
            </span>
            <span>
              <em className="faint tiny">ค่าเช่าตอนนี้</em>
              <b className="num bad-text">{owner ? money(rentFor(g, tileId, 7)) : '—'}</b>
            </span>
          </div>

          {tile.kind === 'property' && tile.rent && (
            <div className="rent-table">
              {tile.rent.map((r, i) => (
                <span key={i} className={i === ts.level && owner ? 'now' : ''}>
                  <em className="faint tiny">Lv{i}</em>
                  <b className="num">{short(r)}</b>
                </span>
              ))}
            </div>
          )}

          <div className="tileinfo-owner">
            {owner ? (
              <>
                <span className="tileinfo-dot" style={{ background: owner.character.color }}>
                  {owner.character.emoji}
                </span>
                <span>
                  เจ้าของ: <b>{owner.name}</b>
                  {ts.mortgaged && <span className="pill bad"> 🏚️ จำนองอยู่</span>}
                </span>
              </>
            ) : (
              <span className="faint">ยังไม่มีเจ้าของ — ใครเหยียบก่อนได้สิทธิ์ซื้อก่อน</span>
            )}
          </div>
        </>
      )}
    </div>
  )
}
